import styles from "./styles.module.scss";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import { motion } from "framer-motion";
import useChartOfAccount from "./useChartOfAccount";
import { RoutedModal } from "../../../../components/common";
import { accountTypes } from "../../../../helpers";

const ChartOfAccounts = () => {
  const {
    metaDetails,
    accountsList,
    isLoadingAccountsList,
    isDownloadStatement,
    setIsDownloadStatement,
    gotoPage,
    handleFetchAccountsList,
    showAddBankAccount,
    setShowAddBankAccount,
    showAddChartAccount,
    setShowAddChartAccount,
    search,
    filterBySearch,
    filterByAccountType,
  } = useChartOfAccount();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Cash Accountings Transaction"
      description="View all Cash accountings Transaction"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          className={` ${globalStyles.pageColumnGaps}`}
        >
          <div className="d-flex flex-wrap justify-content-between align-items-center mt-2">
            <div>
              <h4 className="font-weight-semibold">Chart of Accounts</h4>
              <p className="default-text-size">
                Manage your financial structure and account balances
              </p>
            </div>
            <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Accounting"}
                permissionChildKey="can_create_ledger_account"
              >
                <secondaryComponents.AddAccountDropdown
                  setShowAddBankAccount={setShowAddBankAccount}
                  setShowAddChartAccount={setShowAddChartAccount}
                />
              </secondaryComponents.NavigateWithPermission>
            </div>
          </div>

          {/* table session */}
          <div className={styles.tableBody}>
            <div className={`${globalStyles.tableHeader} align-items-end`}>
              <primaryComponents.SearchField
                classNames={globalStyles.searchField}
                placeholder="Search by account name, number, code or bank name"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") !== null ? search.get("query") : ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              {/* account type */}
              <div className="ml-auto" style={{ width: "170px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      label: "All Types",
                      value: null,
                    },
                    ...accountTypes,
                  ]}
                  idKey="value"
                  nameKey="label"
                  onChange={(value) => {
                    filterByAccountType(value);
                  }}
                  label={"Filter Account Type"}
                  value={"All Types"}
                  floatError={false}
                />
              </div>
            </div>

            <secondaryComponents.LoaderHelper
              isLoading={isLoadingAccountsList}
              classNames={"mt-5"}
            >
              <secondaryComponents.AllAccountsList
                accounts={accountsList}
                handleFetchAccountsList={handleFetchAccountsList}
                gotoPage={gotoPage}
                metaDetails={metaDetails}
              />
            </secondaryComponents.LoaderHelper>

            {/* download statement */}
            <secondaryComponents.SideModal
              isActive={isDownloadStatement}
              closeModal={() => setIsDownloadStatement(false)}
            >
              <secondaryComponents.StoreWalletDownloadStatement
                closeWidget={() => setIsDownloadStatement(false)}
                selectedStoreId={1}
                type="cash"
              />
            </secondaryComponents.SideModal>

            {/* add bank account */}
            <RoutedModal
              width={700}
              headerTitle="Add Bank Account"
              headerDescription="Set up a new bank account to manage your finances effectively."
              style={{ height: "auto" }}
              isActive={showAddBankAccount}
              closeModal={() => setShowAddBankAccount(false)}
            >
              <secondaryComponents.AddBankAccount
                closeWidget={() => setShowAddBankAccount(false)}
                isLoading={isLoadingAccountsList}
                handleFetchBanks={handleFetchAccountsList}
              />
            </RoutedModal>

            {/* add chart account */}
            <RoutedModal
              width={700}
              headerTitle="Add Chart Account"
              headerDescription="Create a new chart account to organize your financial structure."
              isActive={showAddChartAccount}
              closeModal={() => setShowAddChartAccount(false)}
              style={{ height: "auto" }}
            >
              <secondaryComponents.AddChartAccount
                closeWidget={() => setShowAddChartAccount(false)}
                isLoading={isLoadingAccountsList}
                handleFetchBanks={handleFetchAccountsList}
              />
            </RoutedModal>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default ChartOfAccounts;
